<template>
<div class="col-md-12">
    <!-- <p>Catatan Khusus</p> -->
    <!-- <span v-for="data in formdata" :key="data.id_siswa">
        {{data.id_siswa}} <br/>
    </span> -->
    <div class="col-md-12">
        <div class="row" >
            <div class="form-group col-md-4">
                <label>Awal Laporan</label>
                <date-picker v-model="form.awal_mr" valueType="format" input-class="form-control" style="width: 100%;"></date-picker>
                <has-error :form="form" field="awal_mr"></has-error>
            </div>
            <div class="form-group col-md-4">
                <label>Akhir Laporan</label>
                <date-picker v-model="form.akhir_mr" valueType="format" input-class="form-control" style="width: 100%;"></date-picker>
                <has-error :form="form" field="akhir_mr"></has-error>
            </div>
            <div class="form-group col-md-4">
                <label>Bulan Laporan</label>
                <date-picker v-model="form.bulan_mr" type="month" valueType="format" input-class="form-control" style="width: 100%;"></date-picker>
                <has-error :form="form" field="bulan_mr"></has-error>
            </div>
            <!-- Upload PDF (opsional) -->
            <div class="form-group col-md-12">
              <label>Upload PDF Laporan (opsional)</label>
              <input
                type="file"
                accept="application/pdf"
                class="form-control-file"
                @change="onPdfChange"
              />
              <small v-if="pdfName" class="text-muted d-block mt-1">
                File dipilih: {{ pdfName }}
              </small>

              <!-- LINK LIHAT FILE YANG SUDAH ADA -->
              <div v-if="existingPdfUrl" class="mt-2">
                <a
                  :href="existingPdfUrl"
                  target="_blank"
                  rel="noopener"
                  class="btn btn-outline-primary btn-sm"
                >
                  Lihat PDF saat ini
                </a>
              </div>

              <div
                v-if="form.errors && form.errors.has('pdf_file')"
                class="invalid-feedback d-block"
              >
                {{ form.errors.get('pdf_file') }}
              </div>
            </div>


            <div class="form-group col-md-12">
                <label>Catatan</label>
                  <textarea v-model="form.catatan" type="text" name="catatan"
                                class="form-control" :class="{ 'is-invalid': form.errors.has('catatan') }" rows="2" placeholder="Contoh : Mengulang Proses" >
                  </textarea>
                  <has-error :form="form" field="catatan"></has-error>
            </div>

        </div>
    </div>

    <div v-for="(inputdata, index) in formlaporan" :key="index">
        <div class="card mb-4 py-3 border-left-primary">
          <div class="card-header py-3">
              <h6 class="m-0 font-weight-bold text-primary">Data Laporan Aspek Perkembangan {{index+1}}</h6>
          </div>
          <div class="card-body">  
            <div class="row">
                  <div class="form-group col-md-12">
                      <label>Aspek </label>
                        <Select2 name="id_aspek[]" v-model="form.id_aspek[index]" :options="listaspek" @change="myChangeEvent($event)" @select="mySelectEvent($event)" /></Select2>
                        <has-error :form="form" field="id_aspek"></has-error>
                  </div>
                  <div class="form-group col-md-12">
                      <label>Narasi</label>
                        <textarea v-model="form.narasi[index]" type="text" name="narasi"
                                      class="form-control" :class="{ 'is-invalid': form.errors.has('narasi') }" rows="2" placeholder="Contoh : Mengulang Proses" >
                        </textarea>
                        <has-error :form="form" field="narasi"></has-error>
                  </div>
                  <div class="col-md-12 " align="left">
                      <button class="btn btn-danger" @click.prevent="deleteRow(index,inputdata)">Hapus Laporan {{index+1}}</button>
                  </div>
            </div>
          </div>
      </div>
    </div>

    <div class="col-md-12">
        <div class="row" >
              <div class="col-md-3">
                  <button class="btn btn-primary" @click.prevent="addRow">Tambah Laporan</button>
              </div>
              <div class="col-md-6">
                  &nbsp;
              </div>
              <div class="col-md-3" align="right">
                  <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
                  <button type="submit" class="btn btn-success" @click.prevent="Save()">Simpan</button>
              </div>
          </div>
    </div>
</div>
</template>

<script>
    import DatePicker from 'vue2-datepicker';
    import 'vue2-datepicker/index.css';
    import Select2 from '../../../components/Select2.vue';

    export default {
        components: {
          DatePicker,
          Select2,
        },
        name:'laporanbulanan',
        props: ['SiswaId','DateKegiatan'],
        async mounted() {
            // console.log('Component mounted.'+this.SiswaId)
            this.$Progress.start();
            await this.loadData()
            await this.loadAspek()
            this.user = JSON.parse(localStorage.getItem('user'))
            this.$Progress.finish();
        },
        data() {
            return {
              user : '',
              formlaporan : [0],
              formdata : {},
              listaspek : [],
              pdfName: '',
              form: new Form({
                    id : '',
                    id_siswa : '',
                    id_guru : '',
                    bulan_mr: '',
                    tgl_mr:'',
                    awal_mr: '',
                    akhir_mr: '',
                    catatan: '',
                    id_aspek: [],
                    narasi: [],
                    type:'laporanbulanan',
                    pdf_file: null,
              }),
            };
        },
        methods: {
          loadData(){
            axios.get("api/kegiatan-siswa/"+this.SiswaId,{params:{type:'laporanbulanan',date:this.DateKegiatan}}).then(( data ) => {
              this.formdata = data.data.data[0]

              if(data.data.data.length > 0){
                  this.form.id = this.formdata.id;
                  this.form.id_guru = this.user.id;
                  this.form.bulan_mr = this.formdata.bulan_mr;
                  this.form.tgl_mr = this.formdata.tgl_mr;
                  this.form.awal_mr = this.formdata.awal_mr;
                  this.form.akhir_mr = this.formdata.akhir_mr;
                  this.form.catatan = this.formdata.catatan;

                  axios.get("api/kegiatan-siswa/detail-bulanan/"+this.form.id).then(( detail ) => {
                      this.formlaporan = detail.data.data;
                      if(this.formlaporan.length < 1){
                          this.formlaporan.push([]);
                      }else{
                          for(let index in this.formlaporan){
                              this.form.id_aspek[index] = this.formlaporan[index].id_aspek
                              this.form.narasi[index] = this.formlaporan[index].narasi
                          }
                      }
                  });
              }

              this.form.id_siswa = this.SiswaId
              this.form.tgl_catatan_khusus = this.DateKegiatan

            })
            .catch((data)=>{
                  setTimeout(() => {
                      Toast.fire({
                          icon: 'error',
                          title: 'Some error occured! Please try again'
                      });
                      if(data.response.status == 401){
                          this.$emit('logout')
                      }
                  }, 300);
              });
          },
          loadAspek(){
            axios.get("api/list/aspek").then(({ data }) => (this.listaspek = data.data));
          },
          onPdfChange(e) {
            const file = e.target.files && e.target.files[0] ? e.target.files[0] : null;
            if (!file) {
              this.form.pdf_file = null;
              this.pdfName = '';
              return;
            }

            // Validasi ringan di sisi client
            const isPdf = file.type === 'application/pdf' || /\.pdf$/i.test(file.name);
            const maxSize = 5 * 1024 * 1024; // 5 MB

            if (!isPdf) {
              Toast.fire({ icon: 'warning', title: 'File harus PDF' });
              e.target.value = '';
              return;
            }
            if (file.size > maxSize) {
              Toast.fire({ icon: 'warning', title: 'Ukuran PDF maks 5MB' });
              e.target.value = '';
              return;
            }

            this.form.pdf_file = file;
            this.pdfName = file.name;
          },

          clearNewPdf() {
            this.pdfFile = null;
            this.pdfName = '';
          },

          markRemovePdf() {
            this.removePdf = true;
            this.clearNewPdf();
          },

          undoRemovePdf() {
            this.removePdf = false;
          },
          async Save() {
            this.$Progress.start();
            $('#pageloader').css('display','block');
            this.isActiveLoading = true;

            try {
              let id = this.form.id ? this.form.id : 0;
              this.form.id_guru = this.user.id;

              // Bangun FormData manual agar file terkirim
              const fd = new FormData();
              fd.append('_method', 'PUT'); // spoofing -> route update tetap kepanggil
              fd.append('type', 'laporanbulanan');
              fd.append('id_siswa', this.form.id_siswa || '');
              fd.append('id_guru',  this.form.id_guru  || '');
              fd.append('bulan_mr', this.form.bulan_mr || '');
              fd.append('tgl_mr',   this.form.tgl_mr   || '');
              fd.append('awal_mr',  this.form.awal_mr  || '');
              fd.append('akhir_mr', this.form.akhir_mr || '');
              fd.append('catatan',  this.form.catatan  || '');

              // array kirim sebagai multiple fields
              (this.form.id_aspek || []).forEach(v => fd.append('id_aspek[]', v ?? ''));
              (this.form.narasi  || []).forEach(v => fd.append('narasi[]',   v ?? ''));

              // file PDF (opsional)
              if (this.form.pdf_file) {
                fd.append('pdf_file', this.form.pdf_file);
              }

              const { data } = await axios.post(`api/kegiatan-siswa/${id}`, fd, {
                headers: { 'Content-Type': 'multipart/form-data' },
                onUploadProgress: (e) => {
                  // opsional: progress bar
                  // const percent = Math.round((e.loaded * 100) / e.total);
                }
              });

              if (data && data.success) {
                setTimeout(() => {
                  this.isActiveLoading = false;
                  Toast.fire({ icon: 'success', title: data.message });
                  $('#pageloader').css('display','none');
                  this.$Progress.finish();
                  this.form.id = data.data.id; // simpan id kalo sebelumnya 0
                }, 300);
              } else {
                setTimeout(() => {
                  this.isActiveLoading = false;
                  Toast.fire({ icon: 'error', title: 'Some error occured! Please try again' });
                  $('#pageloader').css('display','none');
                  this.$Progress.failed();
                }, 300);
              }
            } catch (err) {
              setTimeout(() => {
                this.isActiveLoading = false;

                // mapping error validasi ke vform errors (422)
                if (err.response && err.response.status === 422 && err.response.data && err.response.data.errors) {
                  this.form.errors.set(err.response.data.errors);
                }

                Toast.fire({ icon: 'error', title: 'Some error occured! Please try again' });
                if (err.response && err.response.status == 401) this.$emit('logout');

                $('#pageloader').css('display','none');
                this.$Progress.fail();
              }, 300);
            }
          },

          addRow() {
            this.formlaporan.push([]);
          },
          deleteRow(index,val) {
            if(this.formlaporan.length > 1){
              this.formlaporan.splice(index,1);
              this.form.id_aspek.splice(index, 1);
              this.form.narasi.splice(index, 1);
            }else{
              this.deleteFailed(index,val);
            }
          },
          deleteFailed(index,val) {
            Toast.fire({
                icon: 'error',
                title: 'Gagal Hapus, Minimal 1 Kegiatan'
            });
          },
          mySelectEvent(event){

          },
          myChangeEvent(event){

          },
        },
        computed: {
          existingPdfUrl() {
            // contoh DB: "monthly_reports/abc.pdf"
            const p = this.formdata && this.formdata.file ? String(this.formdata.file) : '';
            if (!p) return null;

            // kalau backend kirim URL penuh, langsung pakai
            if (/^https?:\/\//i.test(p)) return p;

            // asumsi file ada di public/monthly_reports (tanpa symlink)
            const clean = p.replace(/^\/+/, '').replace(/^public\//, ''); // jaga-jaga kalau tersimpan "public/monthly_reports/..."
            return `${window.location.origin}/${clean}`; // → https://domain.com/monthly_reports/abc.pdf
          }

        },

    }
</script>
